/**
 * Rounds a number to a given number of decimal places.
 * @param {number} value - number to round
 *
 * @returns {number} rounded number
 */
export const roundTo = (value) => {
  const factor = Math.pow(10, 2)

  return Math.round(value * factor) / factor
}
